<template>
	<!-- Smart TVs use a fixed, viewport-filling embed player; page sponsors would overlap it. -->
	<Layout :show-footer-sponsors="!$arenaConfig.isSmartTv">
		<NavBack
			v-if="$Helpers.getBackUrl()"
			:link="$Helpers.getBackUrl()"
			:title="$I18n.trans('commons.back')"
		/>
		<PrivateEvent
			v-if="eventIsProtected && !passwordUnlocked"
			:event-id="eventId"
			:pw-protected="passwordEnabled"
		/>
		<AgeConfirmationModal
			v-else-if="requiresAgeConfirmation && !ageConfirmed"
			@confirmed="handleAgeConfirmed"
			@denied="handleAgeDenied"
		/>
		<template v-else>
			<template v-if="paymentRestricted">
				<KronePaymentModal
					v-if="$arenaConfig.isKrone"
					:event="event"
				/>
				<template v-else>
					<PaywallModal
						:event="event"
					/>
					<PaymentModal
						:event="event"
						:checkout="checkout"
					/>
				</template>
			</template>
			<div
				v-if="$arenaConfig.isSmartTv"
				class="l-smart-tv-wrapper"
			>
				<div id="embed-view-mode">
					<!-- Player goes here -->
				</div>
			</div>
			<div
				v-else
				class="l-container l-container--full-width@mobile u-flex-grow-1"
			>
				<div id="full-page-mode">
					<!-- Player goes here -->
				</div>
			</div>
		</template>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import PrivateEvent from '@js/components/PrivateEvent';
import PaymentModal from '@js/components/Payments/PaymentModal';
import KronePaymentModal from '@js/components/Krone/KronePaymentModal';
import PaywallModal from '@js/components/Payments/PaywallModal';
import NavBack from '@js/components/NavBack';
import AgeConfirmationModal, { LOCAL_STORAGE_KEY } from '@js/components/AgeConfirmationModal';
import laroute from '@laroute';
import { safeLocalStorage } from '@shared/js/safeWebStorage';

export default {
	name:       'ViewEvent',
	components: { Layout, PrivateEvent, KronePaymentModal, PaymentModal, PaywallModal, NavBack, AgeConfirmationModal },
	props:      {
		eventIsProtected: {
			type:     Boolean,
			required: true,
		},
		passwordUnlocked: {
			type:     Boolean,
			required: true,
		},
		eventId: {
			type:     Number,
			required: true,
		},
		passwordEnabled: {
			type:     Boolean,
			required: true,
		},
		paymentRestricted: {
			type:     Boolean,
			required: true,
		},
		event: {
			type:     Object,
			required: true,
		},
		checkout: {
			type:     Boolean,
			required: true,
		},
	},
	data() {
		return {
			requiresAgeConfirmation: false,
			ageConfirmed:            false,
		};
	},
	computed: {
		requiresAgeVerification() {
			const ageRestrictedEventIds = this.$arenaConfig?.ageRestrictedEventIds || [];
			return this.event && ageRestrictedEventIds.includes(this.event.id.toString());
		},
	},
	watch: {
		event: {
			handler(newEvent) {
				if (newEvent && this.requiresAgeVerification) {
					// Check localStorage first
					const storedConfirmation = safeLocalStorage.getItem(LOCAL_STORAGE_KEY);
					if (storedConfirmation === 'true') {
						this.ageConfirmed = true;
					} else {
						this.requiresAgeConfirmation = true;
						this.$nextTick(() => {
							window.eventBus.$emit('modal:AgeConfirmationModal');
						});
					}
				}
			},
			immediate: true,
		},
	},
	methods: {
		handleAgeConfirmed() {
			this.ageConfirmed = true;
			this.requiresAgeConfirmation = false;
		},
		handleAgeDenied() {
			// Redirect to home
			window.location.href = laroute.route('arena.home');
		},
	},
};
</script>

<style>

</style>
